<template>
	<div v-if="page && page.context" :aria-busy="page.isLoading">
		<component :is="component" v-bind="$attrs">
			<template v-for="(_, name) in slots" #[name]="slotData">
				<slot :name="name" v-bind="slotData" />
			</template>
		</component>
	</div>
</template>

<script setup>
import {computed, useSlots} from 'vue';
import {useCMS} from '#nk/composables/cms';
const slots = useSlots();

const page = useCMS();

function componentName(name) {
	let pageLayoutName = name;
	if (!pageLayoutName) return '';
	pageLayoutName = pageLayoutName.toString();
	pageLayoutName =
		pageLayoutName.charAt(0).toUpperCase() + pageLayoutName.slice(1);
	return `NkPage${pageLayoutName}`;
}

const component = computed(() => {
	return componentName(page.value.layout);
});
</script>
